import fetch from './fetch'; 
import fetchFile from './fetchFile'; 
//批量导入
export function getExcel(params = {}) {
    return fetch.post(`/yacj/getExcel`, params);
}
// 医案库详情 ======================
// 查询我的医案库列表
export function highSearch(params = {}) {
    return fetchFile.get(`/ckcest/consilia/highSearch`, { params });
}
